export const YEARLY = "YEARLY";
export const MONTHLY = "MONTHLY";
export const QUARTERLY = "QUARTERLY";
